// extracted by mini-css-extract-plugin
export var hideEditor = "_lx-2";
export var infoIcon = "_lx-3";
export var label = "_lx-1";
export var labelContainer = "_lx-0";
export var readonlyText = "_lx-4";